import { Glyph, cn } from "@motleyhand/design"
import type { ComponentProps } from "react"

export function H1({ children, className, ...props }: ComponentProps<"h1">) {
  return (
    <h1
      className={cn(
        "mb-4 scroll-m-20 text-center font-title text-4xl font-normal tracking-tight text-balance not-first:mt-8",
        className,
      )}
      {...props}
    >
      <Glyph variant="staggered-bars" size={24} className="mr-2" />
      {children}
    </h1>
  )
}

export function H2({ children, className, ...props }: ComponentProps<"h2">) {
  return (
    <h2
      className={cn(
        "mb-4 scroll-m-20 border-b pb-2 font-title text-2xl font-normal tracking-tight not-first:mt-8 first:mt-0",
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  )
}

export function H3({ children, className, ...props }: ComponentProps<"h3">) {
  return (
    <h3
      className={cn(
        "mb-4 scroll-m-20 font-title text-xl font-medium tracking-tight not-first:mt-8",
        className,
      )}
      {...props}
    >
      {children}
    </h3>
  )
}

export function H4({ children, className, ...props }: ComponentProps<"h4">) {
  return (
    <h4
      className={cn(
        "mb-4 scroll-m-20 text-lg font-semibold tracking-wide uppercase not-first:mt-8",
        className,
      )}
      {...props}
    >
      {children}
    </h4>
  )
}

export function P({ children, className, ...props }: ComponentProps<"p">) {
  return (
    <p className={cn("leading-6 not-first:mt-2", className)} {...props}>
      {children}
    </p>
  )
}

export function UL({ children, className, ...props }: ComponentProps<"ul">) {
  return (
    <ul className={cn("my-6 ml-6 list-disc [&>li]:mt-2", className)} {...props}>
      {children}
    </ul>
  )
}

export function BlockQuote({
  children,
  className,
  ...props
}: ComponentProps<"blockquote">) {
  return (
    <blockquote
      className={cn(
        "my-4 rounded-r-lg border-l-[3px] border-spark-orange bg-spark-orange/5 px-4 py-3 text-sm leading-6 italic dark:bg-spark-orange/8 [&_cite]:mt-1 [&_cite]:block [&_cite]:text-xs [&_cite]:not-italic [&_cite]:opacity-50 [&_footer]:mt-1 [&_footer]:block [&_footer]:text-xs [&_footer]:not-italic [&_footer]:opacity-50 [&_p]:mb-1.5",
        className,
      )}
      {...props}
    >
      {children}
    </blockquote>
  )
}

export function Code({
  children,
  className,
  ...props
}: ComponentProps<"code">) {
  return (
    <code
      className={cn(
        "relative rounded bg-muted p-1 font-mono text-sm font-semibold",
        className,
      )}
      {...props}
    >
      {children}
    </code>
  )
}
export function A({ children, className, ...props }: ComponentProps<"a">) {
  return (
    <a
      className={cn(
        "text-foreground underline underline-offset-4 hover:decoration-2",
        className,
      )}
      {...props}
    >
      {children}
    </a>
  )
}

export function HR({ className, ...props }: ComponentProps<"hr">) {
  return <hr className={cn("my-8", className)} {...props} />
}
